// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { QuickWinContentData, ContentMetadata_QUICKWIN, ContentMetadata_SUMMARY, QuickWinContent } from "../schema";
import { serialize_QuickWinContentData_internal, deserialize_QuickWinContentData_internal } from "./QuickWinContentData";
import { serialize_ContentMetadata_QUICKWIN_internal, deserialize_ContentMetadata_QUICKWIN_internal } from "./ContentMetadata_QUICKWIN";
import { serialize_ContentMetadata_SUMMARY_internal, deserialize_ContentMetadata_SUMMARY_internal } from "./ContentMetadata_SUMMARY";

export function serialize_QuickWinContent_internal(value: QuickWinContent): unknown {
  return ((value: { content: QuickWinContentData; metadata: ContentMetadata_QUICKWIN; summary: ContentMetadata_SUMMARY }): unknown => {
    return {
      content: ((value: QuickWinContentData): unknown => {
        return serialize_QuickWinContentData_internal(value);
      })(value["content"]),
      metadata: ((value: ContentMetadata_QUICKWIN): unknown => {
        return serialize_ContentMetadata_QUICKWIN_internal(value);
      })(value["metadata"]),
      summary: ((value: ContentMetadata_SUMMARY): unknown => {
        return serialize_ContentMetadata_SUMMARY_internal(value);
      })(value["summary"]),
    };
  })(value);
}
export function serialize_QuickWinContent(obj: QuickWinContent): string {
  return renderJsonWithNumbersAsBigint(serialize_QuickWinContent_internal(obj));
}
export function deserialize_QuickWinContent_internal(value: unknown): ParserResult<QuickWinContent> {
  return ((
    value: unknown,
  ): ParserResult<{
    content: QuickWinContentData;
    metadata: ContentMetadata_QUICKWIN;
    summary: ContentMetadata_SUMMARY;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/QuickWinContent]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/QuickWinContent]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "content")) {
      return { success: false, reason: `[#/components/schemas/QuickWinContent/content]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'content'.` };
    }
    const parsed_content = ((): ParserResult<QuickWinContentData> => {
      return ((value: unknown): ParserResult<QuickWinContentData> => {
        return deserialize_QuickWinContentData_internal(value);
      })(value["content"]);
    })();
    if (!parsed_content.success) {
      return { success: false, reason: parsed_content.reason };
    }
    if (!hasProp(value, "metadata")) {
      return { success: false, reason: `[#/components/schemas/QuickWinContent/metadata]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'metadata'.` };
    }
    const parsed_metadata = ((): ParserResult<ContentMetadata_QUICKWIN> => {
      return ((value: unknown): ParserResult<ContentMetadata_QUICKWIN> => {
        return deserialize_ContentMetadata_QUICKWIN_internal(value);
      })(value["metadata"]);
    })();
    if (!parsed_metadata.success) {
      return { success: false, reason: parsed_metadata.reason };
    }
    if (!hasProp(value, "summary")) {
      return { success: false, reason: `[#/components/schemas/QuickWinContent/summary]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'summary'.` };
    }
    const parsed_summary = ((): ParserResult<ContentMetadata_SUMMARY> => {
      return ((value: unknown): ParserResult<ContentMetadata_SUMMARY> => {
        return deserialize_ContentMetadata_SUMMARY_internal(value);
      })(value["summary"]);
    })();
    if (!parsed_summary.success) {
      return { success: false, reason: parsed_summary.reason };
    }
    return { success: true, value: { content: parsed_content.value, metadata: parsed_metadata.value, summary: parsed_summary.value } };
  })(value);
}
export function deserialize_QuickWinContent(str: string): ParserResult<QuickWinContent> {
  return deserialize_QuickWinContent_internal(parseJsonWithNumbersAsBigint(str));
}
